/* Source: /app/components/Mobile/MobileModeSwitcher.cl.jac */
import {__jacJsx, __jacSpawn} from "@jac/runtime";
import { Code2, Braces, FileCode, ChevronDown, X, Check } from "lucide-react";
import { cn } from "../../lib/utils.js";
import { useState } from "@jac/runtime";
function MobileModeSwitcher(props) {
  let mode = (props.mode || "jac");
  let onModeChange = props.onModeChange;
  let className = (props.className || "");
  const [isOpen, setIsOpen] = useState(false);
  let modes = [{"id": "jac", "icon": Code2, "label": "Jac", "shortLabel": "Jac"}, {"id": "jac2py", "icon": Braces, "label": "Jac \u2192 Python", "shortLabel": "jac2py"}, {"id": "py2jac", "icon": FileCode, "label": "Python \u2192 Jac", "shortLabel": "py2jac"}];
  let currentMode = modes.find(m => {
    return (m["id"] === mode);
  });
  let CurrentIcon = ((currentMode && currentMode["icon"]) || Code2);
  function handleModeSelect(modeId) {
    if (onModeChange) {
      onModeChange(modeId);
    }
    setIsOpen(false);
  }
  return __jacJsx("div", {"className": cn("relative", className)}, [__jacJsx("button", {"onClick": () => {
    setIsOpen(!isOpen);
  }, "className": cn("flex items-center gap-1.5 px-2.5 py-1.5 rounded-full", "bg-primary/10 border border-primary/20", "text-primary text-xs font-medium", "transition-all active:scale-95"), "aria-label": "Switch mode", "aria-expanded": isOpen}, [__jacJsx(CurrentIcon, {"className": "w-3.5 h-3.5"}, []), __jacJsx("span", {}, [((currentMode && currentMode["shortLabel"]) || "Jac")]), __jacJsx(ChevronDown, {"className": cn("w-3 h-3 transition-transform", (isOpen && "rotate-180"))}, [])]), (isOpen && __jacJsx(null, {}, [__jacJsx("div", {"className": "fixed inset-0 z-[100]", "onClick": () => {
    setIsOpen(false);
  }}, []), __jacJsx("div", {"className": "absolute top-full right-0 mt-2 z-[101] w-48 bg-surface border border-border rounded-xl shadow-xl overflow-hidden"}, [__jacJsx("div", {"className": "p-2 border-b border-border bg-surface-hover"}, [__jacJsx("span", {"className": "text-[10px] font-semibold text-text-secondary uppercase tracking-wider"}, ["Switch Mode"])]), modes.map(modeItem => {
    let Icon = modeItem["icon"];
    let isActive = (mode === modeItem["id"]);
    return __jacJsx("button", {"key": modeItem["id"], "onClick": () => {
      handleModeSelect(modeItem["id"]);
    }, "className": cn("w-full flex items-center gap-3 px-3 py-2.5 transition-colors", ((isActive && "bg-primary/10 text-primary") || "hover:bg-surface-hover text-text-primary"))}, [__jacJsx(Icon, {"className": "w-4 h-4"}, []), __jacJsx("span", {"className": "text-sm font-medium flex-1 text-left"}, [modeItem["label"]]), (isActive && __jacJsx(Check, {"className": "w-4 h-4 text-primary"}, []))]);
  })])]))]);
}
export {MobileModeSwitcher};